import { render, staticRenderFns } from "./StockForm.vue?vue&type=template&id=0558fcae&scoped=true"
import script from "./StockForm.vue?vue&type=script&lang=js"
export * from "./StockForm.vue?vue&type=script&lang=js"
import style0 from "./StockForm.vue?vue&type=style&index=0&id=0558fcae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0558fcae",
  null
  
)

export default component.exports